<template>
    <div class="header-nav--wrapper">
        <el-dropdown class="filter-buttons" :hide-on-click="true" trigger="click">
            <span class="el-dropdown-link">
                {{ locale }}    <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(value, key, index) in languages" :key="index">
                    <div @click="setLocale(key)" :class="key === locale ? 'is-active' : ''">
                        {{ value }}
                    </div>
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown :hide-on-click="true" trigger="click">
            <span class="el-dropdown-link">
                {{ user.name }}    <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                    <div @click="$router.push({name: 'Profile'})">
                        {{ $t('navbarProfile') }}
                    </div>
                </el-dropdown-item>
                <!-- <el-dropdown-item>
                    <div @click="$router.push({name: 'UserEdit', params: {user: this.user, isEdit: true}})">
                        Settings
                    </div>
                </el-dropdown-item> -->
                <hr>
                <el-dropdown-item>
                    <div @click="logout">
                        {{ $t('navbarLogout') }}
                    </div>
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { logout } from '@/helpers/helpers'
    import model from '@/model/index'
    import { setI18nLanguage } from '@/i18n/setup/i18n-setup'
    
    export default {
        name: 'navRight',
        data () {
            return {
                activeIndex: 'home'
            }
        },
        computed: {
            ...mapGetters({
                locale: 'getLocale',
                user: 'getCurrentUser'
            }),
            languages () {
                return model.getLanguages()
            }
        },
        created () {
            
        },
        methods: {
            logout,
            setI18nLanguage,
            setLocale (key) {
                this.setI18nLanguage(key)
                localStorage.setItem('locale', key)
                this.$store.dispatch('setLocale', key)
            }
        }
    }
</script>

<style scoped>

    .header-nav--wrapper {
        margin-top: 0px !important;
        position: sticky;   
    }
    .button {
        background: transparent;
        border: none;
        color: #21262e;
        cursor: pointer;
        font-weight: bold;
    }
    .is-active {
        color: #409EFF;
    }
    .el-dropdown-link {
        cursor: pointer;
        padding: 10px;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/Headers/NavRight.vue